import React from 'react';
import "../css/projects.css";
import ProjectCard from './ProjectCard';

const Projects = (props) => {
   return (
      <div className="projects-container">
         <h1>My projects</h1>
         <div className="projects-main-content">
            {
               props.projects.map(project => 
               {
                  return <ProjectCard project={project} key={project.name} />
               })
            }
         </div>
      </div>
   );
}

export default Projects;